import { render, staticRenderFns } from "./order-modal-storage.vue?vue&type=template&id=3abcf7d7&scoped=true"
import script from "./order-modal-storage.vue?vue&type=script&lang=js"
export * from "./order-modal-storage.vue?vue&type=script&lang=js"
import style0 from "./order-modal-storage.vue?vue&type=style&index=0&id=3abcf7d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abcf7d7",
  null
  
)

export default component.exports